import { useEffect } from "react";
import { SUCCESSFUL } from "../constants/webapp";

export function AutofillForm(data, setForm) {
  return useEffect(() => {
    if (data) {
      setForm(data);
    }
  }, [data]);
}

export function findInArray(array, value, key) {
  return array.find((val) => val[key] === value);
}

export const returnObject = (show, object) => {
  return show ? object : [];
};

export const capitalizeText = (event, updateFormValues) => {
  const { name, value } = event.target;
  const newValue = value.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
  updateFormValues({ [name]: newValue });
};

export const capitalize = (value) =>
  value?.replace(/(^\w|\s\w)/g, (m) => m?.toUpperCase());

export function changeToSnakeCase(value) {
  return value
    ?.replaceAll(" ", "_")
    .toLowerCase()
    .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ""); // remove all symbols
}

export function stringfy(value) {
  if (value) return value.replaceAll("_", " ");
}

export function getStatusColor(status) {
  switch (status) {
    case SUCCESSFUL:
      return "green-inverse";
    default:
      break;
  }
}

export function getRegister(source) {
  return `/register/${source?.toLowerCase()}`;
}

export function randomString() {
  return (Math.random() + 1).toString(36).substring(7);
}

export function addSelectItem(item, label_key) {
  return {
    id: item.id,
    name: item?.[label_key] || capitalize(stringfy(item?.id)),
  };
}

// export function useOpenFormHandler({ source, data, title }) {
//   const { contextData } = useAppContext();

//   contextData.showGlobalDrawer({
//     component: <FormLayoutHandler key={source} source={source} data={data} />,
//     title: title || `Update ${source}`,
//   });
// }

// Helper function to convert bytes to human-readable KB/MB
export function formatFileSize(bytes) {
  if (!bytes && bytes !== 0) return "";
  if (bytes >= 1000000) {
    return `${bytes / 1000000} MB`;
  }
  return `${(bytes / 1000).toFixed(0)} KB`;
}
